import React, { ComponentProps, useCallback } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "affinityIcons";
import { styled } from "styled-components";

import { Button, ButtonVariants } from "affinityUI/elements/button";
import { CurrentUser } from "lib/auth/types";

const UserStyleButton = styled(Button)`
  font-size: 0.8rem;
  padding: 0.3rem 0.5rem;
`;

const PanelWrap = styled.div`
  display: flex;
  gap: 1rem;
  text-align: right;
  align-items: center;
  margin-left: 1rem;
`;

const InfoWrap = styled.div`
  min-width: 0;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CurrentUserButton: React.FC<
  ComponentProps<typeof Button> & { currentUser: CurrentUser; expanded?: boolean }
> = ({ currentUser, expanded, onClick, ...props }) => {
  const handleUserClick = useCallback(
    (e) => {
      e.target.blur();
      e.target.closest("button")?.blur();
      onClick?.(e);
    },
    [onClick]
  );
  return (
    <PanelWrap data-testid="current-user-info">
      <InfoWrap style={{}}>
        <strong>
          {currentUser?.firstName[0]} {currentUser?.lastName}&nbsp;
        </strong>
        <br />
        <span>{currentUser.hospital?.name}</span>
      </InfoWrap>
      <UserStyleButton variant={ButtonVariants.INVERTED} {...props} onClick={handleUserClick} data-testid="user-button">
        {expanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </UserStyleButton>
    </PanelWrap>
  );
};
